import React, {Component} from 'react';
import {connect} from 'react-redux';
import paths from 'paths';
import {t} from 'l10n';

import {Link} from 'components/ReactRouterDomLocalized';
import AmateurFilmList from 'components/list/AmateurFilmList';

import {memberDeleteWallPost} from 'reducers/member';

import 'sass/member/MemberAmateurFilmsBlock.scss';
import isMobile from "ismobilejs";

class MemberAmateurFilmsBlock extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    render() {
        let {amateurFilms, openUploadFilmModal, memberDeleteWallPost} = this.props,
            {list, totalCount} = amateurFilms;

        return (
            <aside className="amateur-films-member">
                <div className="content">
                    <div className="heading">
                        <h2>{t('My amateur videos')} <em>{totalCount}</em></h2>
                        <div>
                            {list.length && !isMobile.any ? <Link to={paths.memberAmateurFilms.path} className="list-items">{t('All my amateur videos')}</Link> : null}
                            <a className="add-item" onClick={openUploadFilmModal}>{t('Publish a video')}</a>
                        </div>
                    </div>

                    <AmateurFilmList amateurFilms={list} showDate showStats onDelete={memberDeleteWallPost} />

                    {(list.length && isMobile.any) ? <Link to={paths.memberAmateurFilms.path} className="get-all-films">{t('All my amateur videos')}</Link> : <div className="view-all-placehoder"></div>}
                </div>
            </aside>
        )
    }
}

export default connect(null, ({memberDeleteWallPost}))(MemberAmateurFilmsBlock);


// WEBPACK FOOTER //
// ./src/components/member/MemberAmateurFilmsBlock.js